import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import { addDriver } from "../api/services";

export default function AddDriverModal(props) {
  const [driverInfo, setDriverInfo] = useState({ phone: 0, car_num: "", add_info: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (driverInfo.phone.toString().length === 8) {
      try {
        setLoading(true);
        const res = await addDriver(driverInfo);
        props.setShow(false);
        toast.success(`${res.data.phone} дугаартай жолооч нэмэгдлээ`);
        window.location.reload();
      } catch (err) {
        toast.error(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Утасны дугаар буруу байна");
    }
  };

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Жолооч нэмэх</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <label className="col-3 col-form-label">Утасны дугаар</label>
          <div className="col-9">
            <input type="tel" maxLength={8} className="form-control"
              onChange={(e) => setDriverInfo((prev) => ({ ...prev, phone: parseInt(e.target.value) }))} />
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-3 col-form-label">Машины дугаар</label>
          <div className="col-9">
            <input maxLength={7} type="text" className="form-control"
              onChange={(e) => setDriverInfo((prev) => ({ ...prev, car_num: e.target.value }))} />
          </div>
        </div>
        <div className="row">
          <label className="col-3 col-form-label">Нэмэлт мэдээлэл</label>
          <div className="col-9">
            <input type="text" className="form-control"
              onChange={(e) => setDriverInfo((prev) => ({ ...prev, add_info: e.target.value }))} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={submit} className="btn btn-success" type="submit" disabled={loading}>
          {loading ? <i className="mdi mdi-dots-circle mdi-spin" /> : <><i className="ri-mail-send-line me-2"></i><span>Хадгалах</span></>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
